export function formatearPeso(cantidad) {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
  }).format(cantidad)
}

export function formatearFecha(isoString) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(isoString))
}

export function formatearHora(isoString) {
  return new Intl.DateTimeFormat('es-MX', { hour: '2-digit', minute: '2-digit' }).format(new Date(isoString))
}

export function formatearDia(fechaStr) {
  // Acepta 'YYYY-MM-DD' o ISO string completo; siempre usa fecha local
  let localStr = fechaStr
  if (fechaStr.includes('T')) {
    const d = new Date(fechaStr)
    localStr = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
  }
  const hoy = new Date()
  const mk = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
  if (localStr === mk(hoy)) return 'Hoy'
  const ayer = new Date(); ayer.setDate(ayer.getDate() - 1)
  if (localStr === mk(ayer)) return 'Ayer'
  const [y, m, d] = localStr.split('-').map(Number)
  return new Intl.DateTimeFormat('es-MX', { weekday: 'short', day: 'numeric', month: 'short' }).format(new Date(y, m - 1, d))
}

export function generarFolioTicket() {
  const ahora = new Date()
  const yyyymmdd = ahora.toISOString().slice(0, 10).replace(/-/g, '')
  const rand = Math.floor(Math.random() * 9000) + 1000
  return `T-${yyyymmdd}-${rand}`
}

export const LABEL_METODO = {
  efectivo: 'Efectivo',
  tarjeta: 'Tarjeta',
  transferencia: 'Transferencia',
  fiado: 'Fiado',
}

export function generarTextoWhatsApp(venta, config, folio) {
  const metodo = LABEL_METODO[venta.metodoPago] ?? venta.metodoPago ?? 'Efectivo'
  const lineas = [
    `🧾 *${config.nombreTienda ?? 'Mi Tienda'}*`,
    `_${folio}_`,
    '',
  ]

  venta.items.forEach(item => {
    const esKg = item.unidad === 'kg'
    const precio = esKg
      ? (item.precioFinal ?? item.precio * item.cantidad)
      : item.precio * item.cantidad
    const desc = esKg ? `${item.cantidad}kg ${item.nombre}` : `${item.cantidad}x ${item.nombre}`
    lineas.push(`• ${desc} — ${formatearPeso(precio)}`)
  })

  lineas.push('', `*TOTAL: ${formatearPeso(venta.total)}*`, '', `Pago: ${metodo}`)

  if (venta.metodoPago === 'efectivo' && venta.recibido != null) {
    lineas.push(`Recibido: ${formatearPeso(venta.recibido)}`)
    lineas.push(`Cambio: ${formatearPeso(venta.cambio)}`)
  }

  if (venta.metodoPago === 'fiado' && venta.clienteNombre) {
    lineas.push(`Cliente: ${venta.clienteNombre}`)
  }

  lineas.push('', formatearFecha(venta.fecha), '¡Gracias por su compra! 🙏')
  return lineas.join('\n')
}

export function generarLinkWhatsApp(telefono, texto) {
  const numero = `52${telefono.replace(/\D/g, '').slice(-10)}`
  return `https://wa.me/${numero}?text=${encodeURIComponent(texto)}`
}
